import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
};

const isLoading = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const isEnding = state => ({
  ...state,
  isLoading: false,
});

const hasError = (state, { payload: apiError }) => ({
  ...state,
  isLoading: false,
  apiError,
});

export default createReducer(initialState, {
  [actionTypes.POST_LOCKER_REQUEST]: isLoading,
  [actionTypes.POST_LOCKER_SUCCESS]: isEnding,
  [actionTypes.POST_LOCKER_FAILURE]: hasError,
  [actionTypes.PUT_LOCKER_REQUEST]: isLoading,
  [actionTypes.PUT_LOCKER_SUCCESS]: isEnding,
  [actionTypes.DELETE_LOCKER_REQUEST]: isLoading,
  [actionTypes.DELETE_LOCKER_SUCCESS]: isEnding,
  [actionTypes.DELETE_LOCKER_FAILURE]: hasError,
});
